import { API_URL, API_VERSION } from '@constants';
import { useData } from '@hooks/useData';
import { paths } from '../../types/api';
import { ApiError, useApiConfig } from '@hooks/useApiConfig';

const ENDPOINT_URL = '/srv-mu-services';

const ENDPOINT_URL_WITH_VERSION = `${API_VERSION}${ENDPOINT_URL}` as const;
type url = typeof ENDPOINT_URL_WITH_VERSION;

export type GetPointsServicesInput = paths[url]['post']['parameters']['query'];
export type GetPointsServicesSuccessResponse = paths[url]['post']['responses']['200']['content']['application/json'];

/**
 * Requests endpoint to get paginated points services.
 */
export const useGetPointsServices = () => {
    const { getHeaders, getCommonParameters, handleCommonErrors } = useApiConfig();
    const { setPointsServices, setIsLoadingPointsServices } = useData();

    const request = async (props: GetPointsServicesInput) => {
        setIsLoadingPointsServices(true);

        try {
            const response = await fetch(`${API_URL}${ENDPOINT_URL}`, {
                method: 'POST',
                headers: getHeaders(),
                body: JSON.stringify({ ...getCommonParameters(), ...props }),
            });

            if (!response.ok) {
                const json = await response.json();
                const error = new Error(json.error || '') as ApiError;
                error.statusCode = response.status;
                throw error;
            }

            const data: GetPointsServicesSuccessResponse = await response.json();

            setPointsServices(data);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err: any) {
            handleCommonErrors(err);
        } finally {
            setIsLoadingPointsServices(false);
        }
    };

    return { request };
};
